module.exports = "https://cdn.realtymogul.com/static/media/icon_properties.62a05cf2.svg";